import * as React from 'react';
import { useSelector } from '../../../state';
import { getOnboardingUrl } from '../../../utils';
import { StepContainer } from '../Container';
import { StepHeading } from '../step-heading';

export const BrregStep: React.FC = () => {
  const { bankSelection, id } = useSelector(e => ({
    id: e.founding.id,
    bankSelection: e.founding.bankSelection,
  }));
  const onboardingUrl = getOnboardingUrl(id, bankSelection);
  return (
    <StepContainer>
      <StepHeading>Vent på registrering</StepHeading>

      <p>
        Brønnøy&shy;sund&shy;registrene behandler søknaden din.
        {bankSelection === 'FOLIO_ONBOARDED' ? (
          <>
            {' '}
            Du kan følge med på estimert ventetid i{' '}
            <a href={onboardingUrl}>Folio</a>.
          </>
        ) : (
          <>
            {' '}
            Det kan ta fra dager til uker. Se hvilke saker som behandles nå på{' '}
            <a href="https://www.brreg.no/bedrift/nar-blir-saken-min-behandlet/">
              brreg.no
            </a>
            .
          </>
        )}
      </p>
    </StepContainer>
  );
};
